const FUNNELS = {
  pricingTestJan2023: 'pricing-test-jan-2023',
  ndrPromoJun2023: 'ndr-promo-jun-2023',
  shopify: 'shopify'
};
export default FUNNELS;